import { useCallback } from "react";

import * as MutationRepository from "../repository/mutation";

import type * as DiscountItemMultiShared from "../../../_shared";

export const useCreateDiscountMulti = (
	inputModel: DiscountItemMultiShared.Model.ModelType.DiscountMultiFormModel["InputModel"],
) => {
	const { onCreateDiscountMulti: _onCreateDiscountMulti } = MutationRepository.useDiscountMultiCreateMutation();

	const onCreateDiscountMulti = useCallback(() => {
		_onCreateDiscountMulti(inputModel);
	}, [_onCreateDiscountMulti, inputModel]);

	return {
		onCreateDiscountMulti,
	};
};
